import { makeAutoObservable } from 'mobx'

/**
 * @class DocumentationStore
 * @description This class represents the store for documentation. It manages the state of documentation and is part of the root store.
 */
class DocumentationStore {
	/**
	 * @property {Object} documentations - An object containing documentation indexed by their IDs.
	 */
	documentation = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of DocumentationStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default DocumentationStore
